<template>
  <fieldset class="field-lock-group">
    <label class="field-lock-toggle" :title="buttonTitle" :for="fieldId">
      <div>
        <button type="button" class="btn btn-link" :disabled="!canChange" @click="toggleLock">
          <i :class="[lockClass, 'lock']" />
        </button>
      </div>
    </label>
  </fieldset>
</template>

<script>
export default {
  props: {
    canChange: {
      type: Boolean,
      default: true
    },

    locked: {
      type: Boolean,
      required: true
    },

    fieldId: {
      type: String,
      required: false
    }
  },

  emits: ['change'],

  computed: {
    buttonTitle() {
      return this.locked ? this.i18n.t('helpers.petition.field_locked') : this.i18n.t('helpers.petition.field_unlocked')
    },

    lockClass() {
      return this.locked ? 'icon-lock' : 'icon-lock-open'
    }
  },

  methods: {
    toggleLock() {
      this.$emit('change', !this.locked)
    }
  }
}
</script>

<style lang="scss" scoped>

.btn-link {
  padding: 0;
  border: 0;
  font-size: 25px;
  line-height: normal;
}

.icon-lock {
  color: red;
}

</style>
